export const CONTACT = {
  whatsapp: "+91 92840 60942",
  whatsappLink:
    "https://wa.me/919284060942?text=Hello%20Synergy%20Next%2C%20I%20would%20like%20to%20start%20a%20strategic%20conversation.",
  email: "connect@synergynext.co.in",
  emailLink:
    "mailto:connect@synergynext.co.in?subject=Strategic%20Conversation%20%E2%80%94%20Synergy%20Next",
  address: "Indu Niwas, 6th Lane, Prabhat Road, Pune 411004",
  website: "www.synergynext.co.in",
  instagram: "@synergynext.in",
  instagramLink: "https://instagram.com/synergynext.in",
  linkedin: "linkedin.com/company/synergynextpune",
  linkedinLink: "https://www.linkedin.com/company/synergynextpune",
  disclaimer:
    "Synergy Next is a proprietary consulting firm. All team designations are functional designations used to indicate areas of responsibility and expertise within the firm and have no statutory, legal, corporate, or regulatory implication.",
};

export const IMAGES = {
  logo: "/images/logo.jpeg",
  logoFull: "/images/logo-full.png",
  logoMark: "/images/logo-mark.png",
  metamorphosis: "/images/metamorphosis.jpg",
  sapling: "/images/sapling.jpg",
  seedlings: "/images/seedlings.jpg",
  boardroom: "/images/boardroom.jpg",
  session: "/images/session.jpg",
  doctor: "/images/doctor.jpg",
  educator: "/images/educator.jpg",
  realEstate: "/images/real-estate.jpg",
  familyBusiness: "/images/family-business.jpg",
  school: "/images/school.jpg",
  oak: "/images/oak.jpg",
  sunrise: "/images/sunrise.jpg",
  eagle: "/images/eagle.jpg",
  chessboard: "/images/chessboard.jpg",
  jigsaw: "/images/jigsaw.jpg",
  hospital: "/images/hospital.jpg",
  team: "/images/team.jpg",
  partnership: "/images/partnership.jpg",
  womenLeaders: "/images/team-sofa.jpg",
  womanConsultant: "/images/team-boardroom.jpg",
  succession: "/images/succession.jpg",
  qrLinkedin: "/images/qr-linkedin.png",
  qrInstagram: "/images/qr-instagram.png",
  qrWhatsapp: "/images/qr-whatsapp.png",
};

export const MANIFESTO = [
  {
    number: "01",
    title: "Who We Are",
    text: "Synergy Next is a management and institutional consulting firm. We partner with business owners, promoters, doctors, educators and leadership teams to strengthen strategy, improve management systems, develop people and deliver measurable organisational impact. We are consultants who stay for the implementation — partners in outcomes, not vendors of advice.",
  },
  {
    number: "02",
    title: "Our Story",
    text: "Synergy Next carries forward a 30-year legacy that began with Synergy Communications — a firm that spent three decades working with organisations on advertising and communication. Those years revealed a consistent truth: organisations rarely fail for lack of ideas; they struggle when strategy, people and execution move apart. Synergy Next was born to bring them together.",
    text: "Synergy Next carries forward a 30-year legacy that began with Synergy Communications — a firm that has spent three decades understanding organisations. Those years revealed a consistent truth: organisations rarely fail for lack of ideas; they struggle when strategy, people and execution move apart. Synergy Next was born to bring them together.",
  },
  {
    number: "03",
    title: "Our Philosophy",
    text: "We believe consulting should leave an organisation stronger, not dependent. Every engagement is designed to transfer capability — systems your teams can run, leaders who can carry the strategy, and rhythms that keep improving after we step back. Candour, evidence and measurable impact guide everything we do.",
  },
  {
    number: "04",
    title: "Vision & Mission",
    text: [
      "Our vision is to enable organisations to grow strategically, stay relevant, and create sustainable impact.",
      "Our mission is to create synergy by bringing together our expertise to shape, strengthen, and accelerate organisational performance, build competitive advantage, strategize sustainable growth, and enable consistent delivery.",
    ],
  },
];

export const EVOLUTION = [
  {
    phase: "Phase 01",
    image: IMAGES.sapling,
    title: "Synergy Communications",
    text: "The journey begins — an advertising and communication firm serving organisations across India.",
  },
  {
    phase: "Phase 02",
    image: IMAGES.seedlings,
    title: "Three decades of understanding organisations",
    text: "Three decades across sectors — multiple engagements, one consistent lesson: strategy, people and execution must move together.",
  },
  {
    phase: "Phase 03",
    image: IMAGES.oak,
    title: "Synergy Next",
    text: "The evolution into a management and institutional consulting firm — built for the next stage of our clients' growth. Today, we partner with leadership teams across India to build organisations that endure.",
  },
];

export const VALUES = [
  { title: "Candour over comfort", text: "We tell clients what they need to hear, not what is easy to say." },
  { title: "Evidence over opinion", text: "Diagnosis grounded in data and ground truth, not assumptions." },
  { title: "Implementation over recommendation", text: "A strategy that is not executed is a cost, not an investment." },
  { title: "Capability over dependency", text: "We build our clients' strength, not their reliance on us." },
  { title: "Long-term over transactional", text: "We measure ourselves by where clients are years later." },
  { title: "Impact over activity", text: "Busy is not the goal. Measurable outcomes are." },
];

export const SECTORS = [
  {
    id: "higher-education",
    image: IMAGES.educator,
    name: "Higher Education",
    tagline: "Enabling institutions to lead with purpose. Inspiring lifelong impact.",
    intro:
      "We work with leaders of higher education and technical learning organisations to strengthen strategy, leadership, systems and institutional performance. Institutions shape futures. We strengthen the systems, leadership and culture that make that possible.",
    offerings: [
      { title: "Strategy & Planning", desc: "Strategic planning, growth priorities, institutional performance and roadmap development." },
      { title: "Leadership & Governance", desc: "Leadership development, governance strengthening, decision-making frameworks and committee effectiveness." },
      { title: "People & Organisation", desc: "Organisation design, role clarity, talent management, culture building and succession planning." },
      { title: "Student Experience & Engagement", desc: "Student journey enhancement, engagement programmes, feedback systems and alumni relations." },
      { title: "Institutional Effectiveness", desc: "Operational excellence, process improvement, quality systems and performance management." },
    ],
    engage: [
      { name: "Assess", tag: "Understand. Prioritise. Plan.", desc: "A focused institutional review to identify key strengths, gaps and priorities." },
      { name: "Strengthen", tag: "Improve. Build. Deliver.", desc: "Targeted support in the areas that matter most to enhance capability and performance." },
      { name: "Transform", tag: "Align. Evolve. Grow.", desc: "A long-term partnership for transformation, scale, leadership transition or system redesign." },
    ],
    notDo: [
      "We do not provide subject-specific or academic content advice.",
      "We do not replace existing teams, committees or decision rights.",
      "We do not act as legal, regulatory, audit, tax or financial advisers.",
      "We do not impose one-size-fits-all solutions.",
      "We do not create dependency on external consultants.",
    ],
    closing: "You know your institution best. We partner with you to make it stronger.",
  },
  {
    id: "healthcare",
    image: IMAGES.doctor,
    name: "Healthcare & Medical Practice",
    tagline: "You focus on care. We strengthen the practice behind it.",
    intro:
      "We partner with doctors, clinics, hospitals and healthcare organisations to build stronger practices, capable teams and sustainable growth. Better systems. Stronger teams. Healthier outcomes. Sustainable growth.",
    offerings: [
      { title: "Strategy & Growth", desc: "Clear direction, the right services, a growth roadmap and positioning." },
      { title: "People & Leadership", desc: "Capable teams, clarity of roles, leadership development and succession planning." },
      { title: "Patient Experience", desc: "Better communication, smooth journeys, feedback systems and service excellence." },
      { title: "Practice Efficiency", desc: "Streamlined processes, better coordination and efficient daily operations." },
      { title: "Financial Clarity", desc: "Better visibility, sound planning and informed decisions." },
    ],
    engage: [
      { name: "Assess", tag: "Understand. Prioritise. Plan.", desc: "A focused review to understand your practice, strengths, gaps and priorities." },
      { name: "Strengthen", tag: "Improve. Build. Deliver.", desc: "Targeted support in the areas that will create the greatest impact." },
      { name: "Transform", tag: "Align. Evolve. Grow.", desc: "A longer-term partnership for scale, leadership transition or transformation." },
    ],
    notDo: [
      "We do not provide clinical, medical or treatment advice.",
      "We do not replace specialist experts or technical advisers.",
      "We do not interfere in medical decisions or protocols.",
      "We do not impose one-size-fits-all solutions.",
      "We do not create dependency on external consultants.",
    ],
    closing: "You are the experts in healthcare. We partner to strengthen the practice around your expertise.",
  },
  {
    id: "real-estate",
    image: IMAGES.realEstate,
    name: "Real Estate",
    tagline: "You build spaces. We help build the organisation that makes them possible.",
    intro:
      "We partner with real estate developers and builders to strengthen leadership, people, customer relationships and organisational growth. Strong projects are built on strong foundations within.",
    offerings: [
      { title: "Strategy & Growth", desc: "Clarity on direction, portfolio choices and growth priorities." },
      { title: "Leadership & People", desc: "Leadership depth, clarity of roles and a high-performing, accountable organisation." },
      { title: "Customer & Market Experience", desc: "Stronger customer relationships, sales practices and brand positioning." },
      { title: "Organisational Growth & Transition", desc: "Professionalise the business, navigate transitions and build a future-ready, sustainable organisation." },
    ],
    engage: [
      { name: "Assess", tag: "Understand. Prioritise. Plan.", desc: "A focused review to identify key opportunities and agree on priorities." },
      { name: "Strengthen", tag: "Improve. Build. Deliver.", desc: "Targeted support in the areas that will create the greatest impact." },
      { name: "Transform", tag: "Align. Evolve. Prepare.", desc: "A longer-term partnership for leadership transition, growth or transformation." },
    ],
    notDo: [
      "We do not advise on construction, design, engineering or technical decisions.",
      "We do not replace specialist legal, tax, audit, RERA or financial advisers.",
      "We do not take over leadership decisions or management control.",
      "We do not impose one-size-fits-all models.",
      "We do not create dependency on external consultants.",
    ],
    closing: "You know real estate. We help strengthen the organisation around that expertise.",
  },
  {
    id: "growing-organisations",
    image: IMAGES.familyBusiness,
    name: "Startups, Family Businesses & Growing Organisations",
    tagline: "Ideas create change. Organisations create lasting impact.",
    intro:
      "We partner with startups, family businesses and growing organisations to turn ambition into direction, build capable teams and strengthen leadership — so the business is ready for what comes next. From early traction to scale — built on values, ready for the next chapter.",
    offerings: [
      { title: "Strategy & Growth", desc: "Clarify direction, create future-ready strategy and identify the right growth opportunities." },
      { title: "Leadership & People", desc: "Build strong leadership capability, align teams and create a culture of ownership, trust and accountability." },
      { title: "Customer & Market Experience", desc: "Sharpen your value proposition, strengthen go-to-market approach and build lasting customer relationships." },
      { title: "Organisational Growth & Transition", desc: "Navigate transitions with clarity — build the next line of leadership and prepare your organisation for scale." },
    ],
    engage: [
      { name: "Assess", tag: "Understand. Prioritise. Plan.", desc: "A focused review to identify strengths, gaps and the highest-impact priorities." },
      { name: "Strengthen", tag: "Improve. Build. Deliver.", desc: "Work on priority areas to build capability, strengthen leadership and achieve measurable improvements." },
      { name: "Transform", tag: "Align. Evolve. Lead.", desc: "A longer-term partnership to build a future-ready organisation and position your business for its next phase of growth." },
    ],
    notDo: [
      "We do not interfere in technical, product, technology or operational decisions.",
      "We do not replace specialist legal, tax, audit, investment or technology advisers.",
      "We do not prescribe a one-size-fits-all model.",
      "We do not promise overnight results.",
      "We are not auditors. We are partners in improvement.",
    ],
    closing: "We respect that you are the experts in your business. We partner to strengthen the organisation around it.",
  },
  {
    id: "schools",
    image: IMAGES.school,
    name: "Schools",
    tagline: "School strategy. Stronger leadership. Better institutions.",
    intro:
      "We work with school leadership to make good schools stronger, more organised and ready for what comes next. Schools shape the future. We strengthen the institution behind the learning.",
    offerings: [
      { title: "School Strategy & Growth", desc: "Clarity on direction, priorities and growth opportunities. Plans that are practical and achievable." },
      { title: "Leadership & People", desc: "Stronger leadership. Clear roles. Capable teams. A culture of accountability and collaboration." },
      { title: "School Systems & Management", desc: "Well-designed systems and processes for efficient, consistent and transparent management." },
      { title: "Parent, Student & Stakeholder Experience", desc: "Stronger relationships, better communication and a positive experience for every stakeholder." },
      { title: "Institutional Capability & Transformation", desc: "Build capability. Drive change. Create a future-ready, sustainable institution." },
    ],
    engage: [
      { name: "Assess", tag: "Understand. Prioritise. Plan.", desc: "A focused review of the school across key dimensions with clear priorities and recommendations. Ideal for schools seeking clarity on where to focus next." },
      { name: "Strengthen", tag: "Improve. Build. Deliver.", desc: "Work on priority areas to strengthen systems, capability and performance with measurable improvements. Ideal for schools ready to improve specific areas." },
      { name: "Transform", tag: "Align. Evolve. Lead.", desc: "A long-term partnership to build capability, lead transformation and position the school for its next phase of growth. Ideal for schools aspiring to build future-ready, high-impact institutions." },
    ],
    notDo: [
      "We do not interfere in academic or pedagogical decisions.",
      "We do not prescribe teaching methods or curriculum.",
      "We do not replace your teams.",
      "We are not auditors. We are partners in improvement.",
    ],
    closing: "We respect that you are the experts in education. We partner to strengthen the institution around it.",
  },
];

export const FRAMEWORK = [
  {
    step: "D1",
    name: "Discover",
    desc: "We immerse ourselves in your world — leadership conversations, data, customers and the ground truth of how the organisation actually works.",
    tags: ["Stakeholder Interviews", "Data Review", "Field Immersion"],
  },
  {
    step: "D2",
    name: "Diagnose",
    desc: "We separate symptoms from root causes, examining strategy, structure, systems and skills to find the few levers that matter most.",
    tags: ["Root-Cause Analysis", "Capability Audit", "Priority Mapping"],
  },
  {
    step: "D3",
    name: "Design",
    desc: "We co-create the way forward — strategy, operating models and roadmaps designed with your leadership, not presented to them.",
    tags: ["Strategy Design", "Operating Model", "Roadmap & Milestones"],
  },
  {
    step: "D4",
    name: "Deploy",
    desc: "We work alongside your teams to implement — pilots, SOPs, governance rhythms and dashboards that turn intent into operating reality.",
    tags: ["Pilot Execution", "SOP Rollout", "Review Rhythms"],
  },
  {
    step: "D5",
    name: "Develop",
    desc: "We build leadership and organisational capability so the change holds long after we step back — capability over dependency.",
    tags: ["Leadership Development", "Capability Academies", "Coaching"],
  },
  {
    step: "D6",
    name: "Deliver Impact",
    desc: "We measure what matters, institutionalise the gains and stay accountable for outcomes — not just activity.",
    tags: ["Impact Measurement", "Institutionalisation", "Sustained Review"],
  },
];

export const DIFFERENCE = [
  {
    title: "Diagnosis before prescription",
    text: "We resist the urge to arrive with answers. Every engagement starts with evidence — your data, your people, your ground reality.",
  },
  {
    title: "Co-creation, not presentation",
    text: "Solutions are built with your leadership in working sessions, so ownership lives inside the organisation from day one.",
  },
  {
    title: "Capability transfer by design",
    text: "Every deployment includes developing your people — so when we step back, the systems and the skills stay.",
  },
];

export const ARTICLES = [
  {
    id: "institutions-next-decade",
    image: IMAGES.chessboard,
    title: "The Next Decade Belongs to Institutions, Not Just Enterprises",
    excerpt:
      "Enterprises are built around opportunity; institutions are built around purpose. In thirty years of working with Indian organisations, this single distinction has separated those that endure from those that merely grow.",
    paragraphs: [
      "Enterprises are built around opportunity; institutions are built around purpose. An enterprise asks, 'What can we capture this year?' An institution asks, 'What must exist ten years from now, and what does that demand of us today?' In thirty years of working with Indian organisations, we have watched this single distinction separate those that endure from those that merely grow.",
      "The signals are visible everywhere. Family businesses that professionalise governance before the second generation arrives. Hospitals that invest in patient-experience systems rather than only in equipment. Educational trusts that treat accreditation as a strategy exercise rather than a compliance scramble. In each case, leadership made a deliberate choice to build something that would outlast their own tenure.",
      "Institution-building is not about size or age. We have seen fifteen-person startups operate with institutional discipline — clear decision rights, honest dashboards, succession thinking — and hundred-year-old organisations run entirely on founder memory. The difference is intent, expressed through systems.",
      "What does this mean practically? Three moves matter most. First, separate ownership from management in structure, even before you separate them in people. Second, build a management layer that is developed, not merely promoted. Third, install the rhythms — reviews, dashboards, honest retrospectives — that let the organisation learn faster than its environment changes.",
      "The next decade of Indian growth will reward organisations that can compound. Compounding requires continuity, and continuity requires institution-building. The question for every leadership team is not whether to grow, but whether what they are building can grow without them.",
    ],
  },
  {
    id: "family-business-governance",
    image: IMAGES.succession,
    title: "Why Family Businesses Stumble at the Second Generation — and How Governance Fixes It",
    excerpt:
      "Most family businesses do not fail because the next generation lacks talent. They fail because the transition was never designed — it was assumed.",
    paragraphs: [
      "Most family businesses do not fail because the next generation lacks talent. They fail because the transition was never designed — it was assumed. The founder's authority was personal, built over decades of relationships and instinct. When that authority passes to a successor, it does not transfer automatically. What transfers is only what has been made explicit.",
      "The predictable failure patterns repeat across sectors. Unclear decision rights between siblings or cousins. Senior professional managers caught between family factions. Strategy conversations that happen at the dining table and are relitigated in the boardroom. A next generation that is given responsibility without authority, or authority without preparation.",
      "Governance is the antidote, but not the bureaucratic kind. Effective family-business governance is a set of explicit agreements: a family charter that defines who can work in the business and on what terms; a board with genuine independent voices; decision-rights frameworks that separate family matters from business matters; and a succession process that starts years before it is needed.",
      "The families that navigate succession well share one habit: they discuss the difficult questions early, while relationships are strong and no decision is urgent. Governance designed in calm times holds in difficult ones. Governance improvised in a crisis rarely does.",
      "For founders reading this, the starting point is deceptively simple: write down how decisions will be made when you are not in the room. That single exercise surfaces more truth than a year of informal conversations — and it is the first stone of an institution.",
    ],
  },
  {
    id: "founder-led-to-system-driven",
    image: IMAGES.session,
    title: "From Founder-Led to System-Driven: Building Organisations That Outgrow Their Founders",
    excerpt:
      "There is a moment in every growing organisation when the founder's greatest strength becomes its greatest constraint.",
    paragraphs: [
      "There is a moment in every growing organisation when the founder's greatest strength becomes its greatest constraint. The same person whose judgement built the business now reviews every decision, approves every deviation and personally holds every key relationship. Growth does not stop because opportunity runs out; it stops because the founder runs out of hours.",
      "The shift from founder-led to system-driven is not about removing the founder. It is about converting personal judgement into organisational capability. The founder's instincts about customers become documented positioning. Their quality standards become SOPs. Their negotiation patterns become sales playbooks. What lived in one head becomes the property of the institution.",
      "Three systems carry most of the weight. A decision-rights framework that makes explicit what the founder decides, what others decide, and what no one needs permission for. A management information system that gives the founder confidence through data rather than presence. And a leadership layer developed deliberately — through real responsibility with coaching, not titles without authority.",
      "The emotional dimension deserves honesty. Letting go is not a process problem; it is an identity problem. Founders who navigate it well usually find a new role that is genuinely additive — strategy, key relationships, mentoring — rather than a diluted version of their old one. The goal is not less founder; it is more organisation.",
      "The test of the transition is simple: can the business have an excellent quarter while the founder takes a month's holiday? Until the answer is yes, the organisation is a practice, not an institution. Making that 'yes' possible is some of the most rewarding work we do.",
    ],
  },
  {
    id: "patient-experience-strategy",
    image: IMAGES.hospital,
    title: "Patient Experience Is a Strategy Problem, Not a Service Problem",
    excerpt:
      "Waiting times are a capacity decision. Clarity of communication is a protocol decision. Patient experience is an output of strategy, not a substitute for it.",
    paragraphs: [
      "Ask a hospital leadership team about patient experience and the conversation quickly moves to front-desk behaviour, signage and food quality. These matter, but they are the last mile of a journey designed much earlier — in decisions about specialty mix, doctor engagement models, capacity planning and pricing. Patient experience is an output of strategy, not a substitute for it.",
      "Consider what actually shapes a patient's experience. Waiting times are a capacity and scheduling decision. Clarity of communication is a doctor-engagement and protocol decision. Billing disputes are a pricing-architecture and process decision. The frontline team inherits every one of these choices; they can deliver experience, but they cannot design it.",
      "The hospitals that excel treat experience as a designed system. They map the patient journey end to end, identify the moments that create trust or destroy it, and then trace each moment back to the operational and strategic decisions that produce it. Only then do they train frontline teams — to deliver an experience that has been made deliverable.",
      "The commercial case is equally strong. In our experience, hospitals with systematic experience programmes see it in their numbers: higher referrals from existing patients, better doctor retention, stronger payer negotiations and premium positioning that survives competition. Trust, it turns out, compounds.",
      "For healthcare leaders, the starting question is not 'How do we train our staff to be nicer?' but 'What experience are we strategically committed to, and what must change in our operations to make it inevitable?' That is a boardroom conversation — and it is exactly where patient experience belongs.",
    ],
  },
];
